<template>
  <div @click="close" class="payment-analysis" v-if="seen">
    <div class="card analysis w-25">
      <div class="card-body">
        <h5>Total amount due analysis</h5>
        <p>If there are available funds in your credit balance, its total sum will be deducted from your total billing amount.</p>
      </div>
    </div>
  </div>
</template>
<style>
  .analysis .card-body {
    text-align: left;
  }

  .analysis .card-body h5 {
    text-align: center;
    margin-bottom: .2em;
  }

  .analysis .card-body p {
    font-size: 14px;
    margin-bottom: .4em;
  }
</style>
<script>
export default {
  data () {
    return {
      seen: false
    }
  },
  methods: {
    load () {
      this.seen = true
    },
    close () {
      this.seen = false
    }
  }
}
</script>
